export default {
    drushim_sub_category_id: 1,
    drushim_category_id: 2,
    jd: 3
}